import React, { useState } from 'react';
import { Container, Row, Col, Image, Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai'; // Importando o ícone de fechar do React Icons

import portugalkesse from '../../img/pm.png';
import umti from '../../img/ti/1.jpg';
import doisti from '../../img/ti/2.jpg';
import tresti from '../../img/ti/3.jpg';
import tresti2 from '../../img/ti/4.avif';
import quatroti from '../../img/ti/4.avif';
import cincoti from '../../img/ti/5.jpg';
import seisti from '../../img/ti/2.jpg';
import seteti from '../../img/ti/1.jpg';
import noveti from '../../img/ti/2.jpg';
import dezti from '../../img/ti/3.jpg';
import onzeti from '../../img/ti/1.jpg';
import { Helmet } from 'react-helmet';
// Importando o CSS
import './TecnologiaDeinformacao.css';

const TecnologiaDeinformacao = () => {
  // Estado para o modal
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Função para abrir o modal com a imagem selecionada
  const handleShowModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setShowModal(true);
  };

  // Função para fechar o modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  return (
    <div>
<Helmet>
  <html lang="pt-BR" />
  <title>Tecnologia da Informação | Inovação e Suporte</title>
  <meta name="description" content="Oferecemos soluções completas em Tecnologias de informação: infraestrutura, redes, segurança digital e suporte técnico especializado." />
  <meta name="keywords" content="tecnologia da informação, suporte técnico, redes, segurança de dados, infraestrutura de Tecnologias de informação" />
  <meta property="og:title" content="Tecnologia da Informação | Inovação e Suporte" />
  <meta property="og:description" content="Melhore a performance do seu negócio com nossas soluções de Tecnologias de informação sob medida." />
  <meta property="og:image" content="https://nwayami.com/img/ti.png" />
  <meta property="og:url" content="https://nwayami.com/tecnologiadeinformacao" />
  <meta name="robots" content="index, follow" />
</Helmet>


<section className="ti-section">
      <Container>
        <h2>Tecnologia de informação</h2>

        {/* Primeira linha (Texto + 4 imagens) */}
        <Row>
          {/* Primeira coluna: Texto */}
          <Col md={6} className="ti-text">
            <p>
              Manutenção Predial: Garantimos a funcionalidade e preservação de suas 
              instalações, eliminando riscos e prolongando a vida útil dos seus ativos.
            </p>
          </Col>

          {/* Segunda coluna: 4 Imagens */}
          <Col md={6} className="ti-image-col-4">
            <Image
              src={umti}
              alt="Imagem 1"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(umti)}
            />
            <Image
              src={doisti}
              alt="Imagem 2"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(doisti)}
            />
            <Image
              src={tresti}
              alt="Imagem 3"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(tresti)}
            />
            <Image
              src={quatroti}
              alt="Imagem 4"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(quatroti)}
            />
          </Col>
        </Row>

        {/* Segunda linha (2 imagens + 1 imagem grande) */}
        <Row className="ti-image-row">
          {/* Primeira coluna da segunda linha: 2 Imagens */}
          <Col md={7} className="ti-image-col-2">
            <Image
              src={cincoti}
              alt="Imagem 5"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(cincoti)}
            />
            <Image
              src={seisti}
              alt="Imagem 6"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(seisti)}
            />
          </Col>

          {/* Segunda coluna da segunda linha: Imagem grande */}
          <Col md={5} className="ti-image-col-large">
            <Image
              src={seteti}
              alt="Imagem 7"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(seteti)}
            />
          </Col>
        </Row>
      </Container>

      {/* Modal para mostrar a imagem completa */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        className="ti-modal" // Classe personalizada para o modal
      >
        <Modal.Body>
          {/* Ícone de fechar usando o React Icons */}
          <AiOutlineClose 
            className="close-icon" 
            onClick={handleCloseModal} 
            title="Fechar" 
          />
          <Image
            src={selectedImage}
            alt="Imagem Grande"
            fluid
            className="ti-image" // Aplicando a classe de estilo para ajustar a imagem
          />
        </Modal.Body>
      </Modal>
    </section>
    </div>
   
  );
};

export default TecnologiaDeinformacao;
